var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamsInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 131,
    viewBox: "0 0 135 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teams"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 131,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 134,
    height: 130,
    rx: 9.5,
    stroke: "#3A3A3A",
    strokeOpacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 26",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M69.3701 55.6757C73.9749 55.6757 77.7079 51.9427 77.7079 47.3378C77.7079 42.733 73.9749 39 69.3701 39C64.7652 39 61.0322 42.733 61.0322 47.3378C61.0322 51.9427 64.7652 55.6757 69.3701 55.6757Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M68.7765 49.1244H61.2266L61.264 49.2904L61.2676 49.3047L61.305 49.4586C62.4385 53.7551 66.8148 56.4316 71.156 55.4826V51.5057C71.1521 50.201 70.0797 49.1283 68.7747 49.1244H68.7765Z",
    fill: "black",
    fillOpacity: 0.098039
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M66.9894 50.9109H61.8369C63.2147 53.8161 66.1552 55.6757 69.3707 55.6757V53.2941C69.3668 51.989 68.2941 50.9166 66.9894 50.9127V50.9109Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M88.129 56.2707C91.5824 56.2707 94.3819 53.4712 94.3819 50.0178C94.3819 46.5643 91.5824 43.7648 88.129 43.7648C84.6755 43.7648 81.876 46.5643 81.876 50.0178C81.876 53.4712 84.6755 56.2707 88.129 56.2707Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M93.489 58.057H79.4449C78.8187 58.057 78.3034 58.5723 78.3034 59.1986V73.6872C78.2228 77.9931 81.193 81.8013 85.3887 82.7719C85.9928 82.8987 86.6082 82.9624 87.2254 82.9624C92.1294 82.9624 96.1655 78.9291 96.1686 74.0251V60.7367C96.1686 59.2666 94.959 58.057 93.489 58.057Z",
    fill: "#5059C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M83.6636 60.7369V77.7169C83.6636 85.5524 77.2159 92 69.3802 92C64.2823 92 59.5565 89.2707 57.0086 84.8549C56.6648 84.2835 56.3662 83.6861 56.1152 83.0684C55.8813 82.4858 55.6846 81.8892 55.5258 81.2819C55.2311 80.1136 55.0812 78.9135 55.0791 77.7088V60.7367C55.0791 60.7356 55.0791 60.7343 55.0791 60.7333C55.0791 59.2651 56.2872 58.057 57.7554 58.057H80.9873C82.4555 58.057 83.6636 59.2651 83.6636 60.7333V60.7369Z",
    fill: "#7B83EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M66.9904 50.9109H61.8379C63.2157 53.8161 66.1562 55.6757 69.3717 55.6757V53.2941C69.3678 51.989 68.2951 50.9166 66.9904 50.9127V50.9109Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M71.1579 58.057V80.6923C71.1579 81.798 70.3804 82.7623 69.2999 82.9969C69.1317 83.0468 68.9571 83.071 68.7817 83.0684H56.1152C55.8813 82.4858 55.6846 81.8892 55.5258 81.2819C55.2311 80.1136 55.0812 78.9135 55.0791 77.7088V60.7367C55.0791 60.7356 55.0791 60.7343 55.0791 60.7333C55.0791 59.2651 56.2872 58.057 57.7554 58.057H71.1579Z",
    fill: "black",
    fillOpacity: 0.098039
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M69.3713 58.057V82.4788C69.3739 82.6542 69.3498 82.8288 69.2999 82.9969C69.0652 84.0774 68.1009 84.8549 66.9952 84.8549H57.0086C56.6648 84.2835 56.3662 83.6861 56.1154 83.0684C55.8813 82.4858 55.6846 81.8892 55.5258 81.2819C55.2311 80.1136 55.0812 78.9135 55.0791 77.7088V60.7367C55.0791 60.7356 55.0791 60.7343 55.0791 60.7333C55.0791 59.2651 56.2872 58.057 57.7554 58.057H69.3713ZM69.3713 58.057V78.9057C69.3654 80.2071 68.2965 81.2759 66.9952 81.2819H55.5258C55.2311 80.1136 55.0812 78.9135 55.0791 77.7088V60.7367C55.0791 60.7356 55.0791 60.7343 55.0791 60.7333C55.0791 59.2651 56.2872 58.057 57.7554 58.057H69.3713ZM57.7588 58.057C57.7577 58.057 57.7564 58.057 57.7554 58.057C56.2872 58.057 55.0791 59.2651 55.0791 60.7333V77.7088C55.0812 78.9135 55.2311 80.1136 55.5258 81.2819H65.2086C66.51 81.2759 67.5788 80.2071 67.5848 78.9057V58.057H57.7588Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M41.3813 50.9109H65.2013C66.5076 50.9109 67.5826 51.9859 67.5826 53.2922V77.1122C67.5826 78.4185 66.5076 79.4935 65.2013 79.4935H41.3813C40.075 79.4935 39 78.4185 39 77.1122V53.2922C39 51.9859 40.075 50.9109 41.3813 50.9109Z",
    fill: "#4B53BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M60.4028 59.7988H55.0627V74.1269H51.5541V59.7988H46.1836V56.2793H60.4028V59.7988Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsInactive);
export default __webpack_public_path__ + "static/media/teamsInactive.1913b28b4d05c2948072e020bb7add6e.svg";
export { ForwardRef as ReactComponent };